import {getDamBaseUrl} from '../custom-hooks/use-dam-image'
import {pathnameStartsWithLocale} from './locale'

export const getCategoryData = (category, categoriesData) => {
    const categoryId = category?.data?.length > 0 ? category.data[0].id : null
    const url = categoriesData[categoryId]?.url
    const displayName = categoriesData[categoryId]?.displayName
    return {categoryId, url, displayName}
}

export const getContentstackLink = (redirects, categoriesData) => {
    const category = redirects?.categorysfcc
    const {url, displayName} = getCategoryData(category, categoriesData)

    if (redirects?.psp_url && redirects?.psp_url[0]) {
        return {url: '/e' + redirects.psp_url[0].url, displayName, isPspUrl: true}
    }

    return {url, displayName, isPspUrl: false}
}

export const getContentstackTertiaryLink = (link, categoriesData) => {
    let url = null
    let label = null
    if (link.iscategorylink && categoriesData) {
        const {url: categoryUrl, displayName} = getContentstackLink(
            {categorysfcc: link.categorysfcc, psp_url: link.psp_url},
            categoriesData,
        )
        url = categoryUrl
        label = link.categorylabel || displayName
    } else {
        label = link?.link?.title
        url = link?.link?.href
    }
    return {url, displayName: label}
}

export const getDamImageUrl = (damImage) => {
    const baseUrl = getDamBaseUrl()
    if (!damImage?.dam_image?.[0]) return null
    return `${baseUrl}/${damImage?.rendition}/assets/${damImage?.dam_image?.[0]?.id}`
}

/**
 * Retrieve url, label and isAbsolute from category, psp link or cta link. Optional 'locale' param will be added to url if not present.
 * @param {Object} link
 * @param {Object} categoriesData
 * @param {string?} locale
 * @returns {{url: string?, label: string?, isAbsolute: boolean}}
 */
export const getGlobalLink = (link, categoriesData, locale = '') => {
    let url = null
    let label = null
    let isAbsolute = false
    // default to url and label from categorysfcc
    if (link?.categorysfcc && link?.categorysfcc.data?.length > 0) {
        const categoryId = link.categorysfcc.data[0].id
        if (categoriesData?.[categoryId]) {
            const categoryUrl = categoriesData[categoryId].url
            url = categoryUrl.includes('?') ? categoryUrl.split('?')[0] : categoryUrl
            label = categoriesData[categoryId].displayName
        }
    }

    // overwrite url if psp_url is set
    if (link?.psp_url && link?.psp_url.length > 0) {
        url = '/e' + link.psp_url[0].url
    }

    // overwrite url and label if cta is set
    if (link?.cta) {
        if (link?.cta?.href) {
            url = link.cta.href
        }
        if (link?.cta?.title) {
            label = link.cta.title
        }
    }

    if (url) {
        isAbsolute = /^(?:[a-z]+:)?\/\//i.test(url)

        if (!isAbsolute) {
            // add starting '/' if not present
            if (/^\//.test(url) ? '' : '/') {
                url = `/${url}`
            }
            // add locale if not present
            if (locale && !pathnameStartsWithLocale(url)) {
                url = `/${locale.toLowerCase()}${url}`
            }
        }
    }

    return {url, label, isAbsolute}
}

// this function will get a relative url and it will check if the locale is already included
// if not it will return the buildUrl(url) orthewise just the url
export const safeBuildUrl = (url, buildUrl) => {
    if (!url) return null
    if (pathnameStartsWithLocale(url)) {
        return url
    }
    return buildUrl(url)
}
